"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:6.4.1'] && _();
}
catch (e) { }
